import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
//#region src/redux/i18n/reducers.ts
var reducers_exports = /* @__PURE__ */ __exportAll({
	updateCountry: () => updateCountry,
	updateLocale: () => updateLocale
});
var updateCountry = (state, { payload }) => {
	state.country = payload?.country;
};
var updateLocale = (state, { payload }) => {
	state.locale = payload?.locale;
};
//#endregion
export { reducers_exports, updateCountry, updateLocale };

//# sourceMappingURL=reducers.js.map